import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const insightsPortalCaperDashboardAccessControl: DomainAccessControlConfig = {
  permissions: Permission.ViewCaperDashboard,
  partnerFeatureTogglesImplicit: FeatureToggle.IppCaperDashboardRetailer,
}
